import React, { Component } from 'react';
import SceButton from "../../../../Common/CommonComponents/sceButton";
import ServiceAccountDetailsComponent from './serviceAccountDetailsComponent';
import overlayClasses from "./pbBulkEnrollOverlaystyles.scss";
import Checkbox from "./SceCheckBox";
import classes from './PbBulkEnrollmentPopup.scss';
import styles from "../../MultiAccountPreference.scss";
import SceTextBox from "../../../../Common/TextBox/sceText";
import { getLocalizedStrings } from "./paperlessBillingPopupLocalisedstrings";
import TermsCondition from "./PbTermsCondition";
import ConfirmationPopup from "./ConfirmationPopup";
import PbPagination from "../../../common/Pagination";
import PaperlessBillingTurnonPopup from "./PaperlessBillingTurnonPopup";
import FocusTrap from 'focus-trap-react';
import SceSelectBox from '../../../common/FilterDropdown/filterDropdown';
export default class extends Component {

    constructor(props) {
        super(props);
        this.strings = getLocalizedStrings("PbBulkEnrollPopup");
        let totalPages = Math.ceil(
            this.props.contractAccountCount / 10
        );
        this.state = {
            counter:1,contractAccountCount:0,unSelectedAccounts:this.props.unSelectedAccounts,selectAllFlow:this.props.selectAllFlow,selectAllCheck: false,  addEmail: false, confPopup: false, isCheckboxClicked: false,
            backToPopup: false, accountData: [],  selectedContractAccountNo: [],accountsInfo: this.props.contractAccountResults, addAccount: false, pagination: "pagination text",
            accountsPerPage: 10, totalPages: totalPages, pageChangeFlag:false, cpcData:[],selectAll:false,selectedType:this.strings.notEnrolled, dropDownError:false,currentPage: 1,hideFilter:true,
            options:[{value:this.strings.notEnrolled,name: this.strings.notEnrolled}, {value:this.strings.ineligible,name: this.strings.ineligible},
                {value:this.strings.alreadyEnrolled,name: this.strings.alreadyEnrolled},] };

        let emailIcon;
        let closeIcon;
        let imageInfo;
        let warningIcon;
        let disabledCheckbox;
        let selectedCheckbox;
        this.disabledCheckbox = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/disabledCheckbox.svg';
        this.emailIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.imageInfo = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Information.svg';
        this.warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
        this.selectedCheckbox = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/selectedCheckbox.svg';
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

    }
    componentDidMount() {     
        if (this.state.selectedContractAccountNo.length === 0) {
            const updatedState = { ...this.state };
            _.isEmpty(this.props.selectedAcct) ? updatedState.selectedContractAccountNo.push(parseInt(this.props.accountData.contractAccountNumber)) :
            updatedState.selectedContractAccountNo = updatedState.selectedContractAccountNo.concat(this.props.selectedAcct);
            this.setState(updatedState);
            this.getMyAccountDetails();
            
        }
         document.addEventListener('mousedown', this.handleClickOutside);
        
    }

    addEmailHandler() { this.setState({ addEmail: true }); }

     //handing drop down
    selectOpitonHandler = (e) => {
        this.setState({selectedType:e.value,dropDownError:false,currentPage: 1}, () => {
            //Get list of contracts from backend as per the filter dropdown.
            this.getMyAccountDetails();
        });
    }

    back() { this.props.isOpen(); }
    
    cancelButtonHandler() { this.props.isOpen();}

    handleCheckClick(isselectAll,e) {

        const updatedState = { ...this.state };
        app.logger.getLogger().info("Paperless Billing Enroll: Checkbox clicked");
        var selected = e.target.checked;
        if(isselectAll){ 
         updatedState.selectAllCheck = !updatedState.selectAllCheck;
         updatedState.selectAllFlow = updatedState.selectAllCheck ? true : false;//checking whether select all is clicked
         updatedState.unSelectedAccounts.clear();
          if(!this.state.selectAllCheck){ 
            for(let i=0;i<this.state.cpcData.contractAccountResults.length;i++)
            { 
                if(this.state.cpcData.contractAccountResults[i].obEnrollmentFlag === 'Not Enrolled' && this.state.cpcData.contractAccountResults[i].isEligible === 'TRUE'){
                    updatedState.selectedContractAccountNo.push(parseInt(this.state.cpcData.contractAccountResults[i].contractAccountNumber));
                }
            } 
            updatedState.counter = updatedState.contractAccountCount;
             let selectedArry= updatedState.selectedContractAccountNo;
             updatedState.selectedContractAccountNo = _.uniq(updatedState.selectedContractAccountNo.concat(selectedArry), 
             (eachAccount)=>{return eachAccount;}) ;
        }
          else{
            updatedState.selectedContractAccountNo=[];
            updatedState.selectedContractAccountNo.push(parseInt(this.props.accountData.contractAccountNumber));
             }
         
      }
      else
    {   
        if (selected) {
            updatedState.selectedContractAccountNo.push(parseInt(e.currentTarget.id));
              if(updatedState.selectAllFlow){
                updatedState.unSelectedAccounts.delete(parseInt(e.currentTarget.id));}
        }
        else {
            var index;
            index = this.state.selectedContractAccountNo.indexOf(parseInt(e.currentTarget.id));
            if (index > -1) {
                updatedState.selectedContractAccountNo.splice(index, 1);
            } 
            if(updatedState.selectAllFlow){
                updatedState.unSelectedAccounts.set(parseInt(e.currentTarget.id));
              }
        } 
    }
   (updatedState.selectAllFlow && updatedState.contractAccountCount>10)?updatedState.counter=updatedState.contractAccountCount-updatedState.unSelectedAccounts.size:updatedState.counter=updatedState.selectedContractAccountNo.length;
    updatedState.counter !== updatedState.contractAccountCount ?updatedState.selectAllCheck = false:updatedState.selectAllCheck = true;
     this.setState(updatedState);}

    addAccountButtonHandler() {
        
        if (this.state.selectedContractAccountNo.length >= 1) {
            let unselected=this.state.unSelectedAccounts;
           let unselectedArray=[];
            unselectedArray =Array.from(unselected.keys());
            this.props.parentCallback(this.state.selectedContractAccountNo,unselectedArray,this.state.selectAllFlow,this.state.contractAccountCount);
        }
        this.props.isOpen();
    }
    componentWillmount() {

        let totalPages = Math.ceil(
            this.props.contractAccountCount / this.state.accountsPerPage
        );
        this.setState({
            totalPages: totalPages,
        });
    }
   
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.props.isOpen();
        // alert("clickoutside bulk");
    
        }
     } 
    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            let totalPages = Math.ceil(
                nextProps.contractAccountCount / this.state.accountsPerPage
            );
            this.setState({ totalPages: totalPages, });
        }
    }

    getSortedResponse(accList,selectedType) {
        switch(selectedType){
            case this.strings.notEnrolled:
                return accList.sort((a,b) => (b.isEligible.localeCompare(a.isEligible) || a.obEnrollmentFlag.localeCompare(b.obEnrollmentFlag)) );
            case this.strings.alreadyEnrolled:
                return accList.sort((a,b) => (a.obEnrollmentFlag.localeCompare(b.obEnrollmentFlag) || b.isEligible.localeCompare(a.isEligible)));
            default:
                return accList.sort((a,b) => (b.obEnrollmentFlag.localeCompare(a.obEnrollmentFlag) || a.isEligible.localeCompare(b.isEligible)));
        }
    }
    getMyAccountDetails = (offset = 0, coOffset = 0) => {
        this.profileData = app.appService.getUserInfo().profileData.profile;
        this.setState({profileData: this.profileData});
        let userType = app.appService.getPrioritisedUserGrp() === app.appUtil.getAppConstants().USER_GROUPS.GUESTUSERS ? 'GUEST' : 'MA';
        let requestType = this.state.selectedType=== this.strings.notEnrolled ? this.strings.notEnrolledEligiable : this.state.selectedType=== this.strings.alreadyEnrolled ? this.strings.enrolled : this.strings.notEnrolledNotEligiable;
        app.centralizedService.getCpcPreference(this.props.bpNumber, this.profileData.eixSCEUID, userType,offset,coOffset, this.strings.programName, requestType, this.props.contractAccountCount)
          .then((response) => {
            if (response.errorCode !== undefined && response.errorCode !== "") {
              this.setState({cpcData: "",webUser: false,loaderDialogBox: false,errorCard: true,preferenceContent: false,
              });
            } else {
              app.appService.setSessionstorage('customerDetails', response.customerDetails);
              let updatedState = {...this.state};     
              if(this.state.selectAllFlow){
                    _.each(response.contractAccountResults,function(eachAccount) {
                      if(!this.state.unSelectedAccounts.has(parseInt(eachAccount.contractAccountNumber)))
                { if (!this.state.selectedContractAccountNo.includes(parseInt(eachAccount.contractAccountNumber)))
                    updatedState.selectedContractAccountNo.push(parseInt(eachAccount.contractAccountNumber));
                }
              },this);

              }
                if (response.filterFlag){
                    response.contractAccountResults = this.getSortedResponse(response.contractAccountResults,this.state.selectedType); 
                }
                updatedState.cpcData= response,updatedState.contractAccountCount=response.contractAccountCount,updatedState.hideFilter=response.filterFlag,
                updatedState.preferenceContent= true,updatedState.webUser= false,updatedState.customerDetails=app.appService.getSessionstorage('customerDetails'),
                updatedState.contractAccountResults=response.response, updatedState.totalPages=offset === 0 ? Math.ceil(response.contractAccountCount/this.state.accountsPerPage) : this.state.totalPages;
               (updatedState.selectAllFlow && updatedState.contractAccountCount>10)?updatedState.counter=updatedState.contractAccountCount-updatedState.unSelectedAccounts.size:updatedState.counter=updatedState.selectedContractAccountNo.length;
               updatedState.selectAllCheck=updatedState.counter === updatedState.contractAccountCount;
               this.setState(updatedState);
            }
          });
      };
      handlePageChange = (selectedPageNumber) => {
        let updatedState={...this.state};
        let offsetValue = selectedPageNumber * 10;
        let offset = selectedPageNumber === 1 ? 0 : offsetValue - 10;
        updatedState.coOffset=((selectedPageNumber-1)*10),updatedState.currentPage=selectedPageNumber;
        !updatedState.selectAllCheck?updatedState.counter =updatedState.counter:updatedState.counter=updatedState.contractAccountCount;
        //Determine offset. coOffset = (selected page number - )*10
       this.setState(updatedState, () => {
            //Get list of contracts from backend as per the page number.
            this.getMyAccountDetails(offset);
        });
      document.getElementById('0').scrollIntoView();
    }  
    
    render() {
        const backButtonJSX = <a href='javascript:;' className={classes.sceSmLink} id={"back"} onClick={this.back.bind(this)}><i className='fas fa-chevron-left' /> &nbsp;{this.strings.BackMsg}</a>;
        return (
            <FocusTrap focusTrapOptions={{ allowOutsideClick: true, }} >
            <div>
                <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}>
                    <div className={overlayClasses.sceOverlayContent}>
                        <div   ref={this.setWrapperRef} className={overlayClasses.sceDialogBox}>
                            <div className='row'>

                                <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.strings.TurnOnPopupTitle}

                                <button className={classes.iconClose} onClick={this.cancelButtonHandler.bind(this)}>
                                    <img  src={this.closeIcon} alt="Close Icon" />
                                    </button>
                                </div>
                            </div>
                            <div className={'sce-space-md ' +classes.backbutton}>{backButtonJSX}</div>
                            <div className={'sce-space-md ' +classes.actSection}>
                                <span className={classes.sceSetNotificationHeader}>{this.strings.AddAccounts} &nbsp; </span>                   
                              {this.state.hideFilter === false ? <div className={classes.pbFilterdiv}>
                                    <span>{this.strings.filterBy}&nbsp;</span>
                                    <div  className={classes.popupFilter}>
                                        <SceSelectBox 
                                            id={"pbFilterdropdown"}
                                            selectBoxData={this.state.options}
                                            handleClick={this.selectOpitonHandler}
                                            displayDefaultText={false}
                                            defaultText={this.state.selectedType}
                                            selected={this.state.selectedType} 
                                        /> 
                                        
                                    </div>
                                </div> : null}
                            </div>
                            <div className='row'>
                                { this.state.selectedType=== this.strings.notEnrolled ? <div className='col-xs-12 '>
                                           <Checkbox id={'checkAll'}name='bulkpopup'  options={<div className='row'><div className="col-xs-4">{"Select All"}</div><div className="col-xs-8">{this.state.counter}{" of "}{this.state.contractAccountCount}{" Acct. selected"}</div></div>} 
                                            handleClick={(event) => this.handleCheckClick(true,event)} selectedOptions={this.state.selectAllCheck}
                                             /> </div>:null} </div>
                            <div className={classes.displayGrey}>
                                <div className={this.state.totalPages > 1? classes.acctData:classes.withoutPages}>                 
                                    {this.state.cpcData.contractAccountResults === undefined ? null :                          
                                    this.state.cpcData.contractAccountResults.map((data,index) => {
                                        let contractActNo = data.contractAccountNumber;
                                        let CAN = data.contractAccountNumber;
                                        let zip = data.zipCode.substr(0, 5);
                                        let streetAdd = data.contractAccountStreetAddress.toLowerCase();
                                        let city = data.city.toLowerCase();
                                        let isChecked = false;
                                        //let obEnrollmentFlag = data.obEnrollmentFlag;
                                        let isEligible = true;
                                        let defaultContractActNo = false;
                                        if (data.obEnrollmentFlag === "Not Enrolled" && data.isEligible === "FALSE")
                                            isEligible = false;
                                        if (contractActNo === this.props.accountData.contractAccountNumber)
                                            defaultContractActNo = true;
                                            let  isDisabled =true;



                                            return (<div id={index} className={classes.accountDisplay}>{(data.obEnrollmentFlag === "Enrolled") ?
                                            <div className={classes.displayAccountsFlex}><div> <img className={classes.imgCheckbox} src={this.disabledCheckbox} alt="Disabled Checkbox" /></div><div><div className={classes.enrolled}>{"ALREADY ENROLLED"}</div> <div className={classes.serviceAct}>{data.houseNumber} <span className={classes.street}>{streetAdd}</span> <span className={classes.street}>{city}</span>, {data.state} {zip}&nbsp;{"- Acct. "}{CAN} </div></div></div>

                                            :
                                            <div> {isEligible ? <div> {defaultContractActNo ?
                                                <div> <Checkbox className={classes.checkBoxContainer} id={contractActNo} name='select' focusOnCheckBoxIcon disabled={isDisabled} handleClick={(event) => this.handleCheckClick(false,event)} selectedOptions={_.contains(this.state.selectedContractAccountNo,parseInt(contractActNo))}   options={<div> <div><span className={classes.serviceAct}>
                                                {data.houseNumber} <span className={classes.street}>{streetAdd}</span> <span className={classes.street}>{city}</span>, {data.state} {zip}&nbsp;{"- Acct. "}  {CAN}</span>   </div> </div>} /></div>
                                                 : <div> <Checkbox className={classes.checkBoxContainer} id={contractActNo} name='bulkpopup' focusOnCheckBoxIcon handleClick={(event) => this.handleCheckClick(false,event)} selectedOptions={_.contains(this.state.selectedContractAccountNo,parseInt(contractActNo))}   options={<div> <div><span className={classes.serviceAct}>
                                                {data.houseNumber} <span className={classes.street}>{streetAdd}</span> <span className={classes.street}>{city}</span>, {data.state} {zip}&nbsp;{"- Acct. "}  {CAN}</span>   </div> </div>} /></div>}</div>
                                                :
                                                <div className={classes.displayAccountsFlex}><img className={classes.imgCheckbox} src={this.disabledCheckbox} alt="Disabled Checkbox" /><div><div className={classes.inEligible}>{"INELIGIBLE"}</div><span className={classes.serviceAct}>
                                                    {data.houseNumber} <span className={classes.street}>{streetAdd}</span> <span className={classes.street}>{city}</span>, {data.state} {zip}&nbsp;{"- Acct. "}
                                                    {CAN} </span></div></div>} </div>}<div className={classes.line} /></div>);
                                    })} </div>


                                {/* Pagination section */}
                                <div className={"row"}>
                                    <div className={"col-xs-12"}>
                                        <div>

                                            <PbPagination
                                                pageCount={this.state.totalPages}
                                                getCurrentIndex={(e) => this.handlePageChange(e)}
                                                pageScale={5}
                                                value={this.props.cpcPageNumber}
                                                currentPage={this.state.currentPage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="text-align-center">

                                <div className={classes.footerButton}>
                                    <div className={classes.turnOnBtn}>

                                        <SceButton
                                            iconType="rightArrow"
                                            buttonType="primary"
                                            value="Add Accounts"
                                            onClick={this.addAccountButtonHandler.bind(this)} />

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>





            </div>
            </FocusTrap>
    
        );
    }
}
